<template>
  <component v-if="type" :is="type"></component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  AccountBookFilled,
  AccountBookOutlined,
  AimOutlined,
  AlertFilled,
  AlertOutlined,
  AlibabaOutlined,
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  AlipayCircleFilled,
  AlipayCircleOutlined,
  AlipayOutlined,
  AlipaySquareFilled,
  AliwangwangFilled,
  AliwangwangOutlined,
  AliyunOutlined,
  AmazonCircleFilled,
  AmazonOutlined,
  AmazonSquareFilled,
  AndroidFilled,
  AndroidOutlined,
  AntCloudOutlined,
  AntDesignOutlined,
  ApartmentOutlined,
  ApiFilled,
  ApiOutlined,
  AppleFilled,
  AppleOutlined,
  AppstoreAddOutlined,
  AppstoreFilled,
  AppstoreOutlined,
  AreaChartOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  ArrowsAltOutlined,
  AudioFilled,
  AudioMutedOutlined,
  AudioOutlined,
  AuditOutlined,
  BackwardFilled,
  BackwardOutlined,
  BankFilled,
  BankOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  BarsOutlined,
  BehanceCircleFilled,
  BehanceOutlined,
  BehanceSquareFilled,
  BehanceSquareOutlined,
  BellFilled,
  BellOutlined,
  BgColorsOutlined,
  BlockOutlined,
  BoldOutlined,
  BookFilled,
  BookOutlined,
  BorderBottomOutlined,
  BorderHorizontalOutlined,
  BorderInnerOutlined,
  BorderLeftOutlined,
  BorderOuterOutlined,
  BorderOutlined,
  BorderRightOutlined,
  BorderTopOutlined,
  BorderVerticleOutlined,
  BorderlessTableOutlined,
  BoxPlotFilled,
  BoxPlotOutlined,
  BranchesOutlined,
  BugFilled,
  BugOutlined,
  BuildFilled,
  BuildOutlined,
  BulbFilled,
  BulbOutlined,
  CalculatorFilled,
  CalculatorOutlined,
  CalendarFilled,
  CalendarOutlined,
  CameraFilled,
  CameraOutlined,
  CarFilled,
  CarOutlined,
  CaretDownFilled,
  CaretDownOutlined,
  CaretLeftFilled,
  CaretLeftOutlined,
  CaretRightFilled,
  CaretRightOutlined,
  CaretUpFilled,
  CaretUpOutlined,
  CarryOutFilled,
  CarryOutOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  CheckOutlined,
  CheckSquareFilled,
  CheckSquareOutlined,
  ChromeFilled,
  ChromeOutlined,
  CiCircleFilled,
  CiCircleOutlined,
  CiOutlined,
  ClearOutlined,
  ClockCircleFilled,
  ClockCircleOutlined,
  CloseCircleFilled,
  CloseCircleOutlined,
  CloseOutlined,
  CloseSquareFilled,
  CloseSquareOutlined,
  CloudDownloadOutlined,
  CloudFilled,
  CloudOutlined,
  CloudServerOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  ClusterOutlined,
  CodeFilled,
  CodeOutlined,
  CodeSandboxCircleFilled,
  CodeSandboxOutlined,
  CodeSandboxSquareFilled,
  CodepenCircleFilled,
  CodepenCircleOutlined,
  CodepenOutlined,
  CodepenSquareFilled,
  CoffeeOutlined,
  ColumnHeightOutlined,
  ColumnWidthOutlined,
  CommentOutlined,
  CompassFilled,
  CompassOutlined,
  CompressOutlined,
  ConsoleSqlOutlined,
  ContactsFilled,
  ContactsOutlined,
  ContainerFilled,
  ContainerOutlined,
  ControlFilled,
  ControlOutlined,
  CopyFilled,
  CopyOutlined,
  CopyrightCircleFilled,
  CopyrightCircleOutlined,
  CopyrightOutlined,
  CreditCardFilled,
  CreditCardOutlined,
  CrownFilled,
  CrownOutlined,
  CustomerServiceFilled,
  CustomerServiceOutlined,
  DashOutlined,
  DashboardFilled,
  DashboardOutlined,
  DatabaseFilled,
  DatabaseOutlined,
  DeleteColumnOutlined,
  DeleteFilled,
  DeleteOutlined,
  DeleteRowOutlined,
  DeliveredProcedureOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  DiffFilled,
  DiffOutlined,
  DingdingOutlined,
  DingtalkCircleFilled,
  DingtalkOutlined,
  DingtalkSquareFilled,
  DisconnectOutlined,
  DislikeFilled,
  DislikeOutlined,
  DollarCircleFilled,
  DollarCircleOutlined,
  DollarOutlined,
  DotChartOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DownCircleFilled,
  DownCircleOutlined,
  DownOutlined,
  DownSquareFilled,
  DownSquareOutlined,
  DownloadOutlined,
  DragOutlined,
  DribbbleCircleFilled,
  DribbbleOutlined,
  DribbbleSquareFilled,
  DribbbleSquareOutlined,
  DropboxCircleFilled,
  DropboxOutlined,
  DropboxSquareFilled,
  EditFilled,
  EditOutlined,
  EllipsisOutlined,
  EnterOutlined,
  EnvironmentFilled,
  EnvironmentOutlined,
  EuroCircleFilled,
  EuroCircleOutlined,
  EuroOutlined,
  ExceptionOutlined,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  ExclamationOutlined,
  ExpandAltOutlined,
  ExpandOutlined,
  ExperimentFilled,
  ExperimentOutlined,
  ExportOutlined,
  EyeFilled,
  EyeInvisibleFilled,
  EyeInvisibleOutlined,
  EyeOutlined,
  FacebookFilled,
  FacebookOutlined,
  FallOutlined,
  FastBackwardFilled,
  FastBackwardOutlined,
  FastForwardFilled,
  FastForwardOutlined,
  FieldBinaryOutlined,
  FieldNumberOutlined,
  FieldStringOutlined,
  FieldTimeOutlined,
  FileAddFilled,
  FileAddOutlined,
  FileDoneOutlined,
  FileExcelFilled,
  FileExcelOutlined,
  FileExclamationFilled,
  FileExclamationOutlined,
  FileFilled,
  FileGifOutlined,
  FileImageFilled,
  FileImageOutlined,
  FileJpgOutlined,
  FileMarkdownFilled,
  FileMarkdownOutlined,
  FileOutlined,
  FilePdfFilled,
  FilePdfOutlined,
  FilePptFilled,
  FilePptOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  FileSyncOutlined,
  FileTextFilled,
  FileTextOutlined,
  FileUnknownFilled,
  FileUnknownOutlined,
  FileWordFilled,
  FileWordOutlined,
  FileZipFilled,
  FileZipOutlined,
  FilterFilled,
  FilterOutlined,
  FireFilled,
  FireOutlined,
  FlagFilled,
  FlagOutlined,
  FolderAddFilled,
  FolderAddOutlined,
  FolderFilled,
  FolderOpenFilled,
  FolderOpenOutlined,
  FolderOutlined,
  FolderViewOutlined,
  FontColorsOutlined,
  FontSizeOutlined,
  ForkOutlined,
  FormOutlined,
  FormatPainterFilled,
  FormatPainterOutlined,
  ForwardFilled,
  ForwardOutlined,
  FrownFilled,
  FrownOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  FunctionOutlined,
  FundFilled,
  FundOutlined,
  FundProjectionScreenOutlined,
  FundViewOutlined,
  FunnelPlotFilled,
  FunnelPlotOutlined,
  GatewayOutlined,
  GifOutlined,
  GiftFilled,
  GiftOutlined,
  GithubFilled,
  GithubOutlined,
  GitlabFilled,
  GitlabOutlined,
  GlobalOutlined,
  GoldFilled,
  GoldOutlined,
  GoldenFilled,
  GoogleCircleFilled,
  GoogleOutlined,
  GooglePlusCircleFilled,
  GooglePlusOutlined,
  GooglePlusSquareFilled,
  GoogleSquareFilled,
  GroupOutlined,
  HddFilled,
  HddOutlined,
  HeartFilled,
  HeartOutlined,
  HeatMapOutlined,
  HighlightFilled,
  HighlightOutlined,
  HistoryOutlined,
  HomeFilled,
  HomeOutlined,
  HourglassFilled,
  HourglassOutlined,
  Html5Filled,
  Html5Outlined,
  IdcardFilled,
  IdcardOutlined,
  IeCircleFilled,
  IeOutlined,
  IeSquareFilled,
  ImportOutlined,
  InboxOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
  InfoOutlined,
  InsertRowAboveOutlined,
  InsertRowBelowOutlined,
  InsertRowLeftOutlined,
  InsertRowRightOutlined,
  InstagramFilled,
  InstagramOutlined,
  InsuranceFilled,
  InsuranceOutlined,
  InteractionFilled,
  InteractionOutlined,
  IssuesCloseOutlined,
  ItalicOutlined,
  KeyOutlined,
  LaptopOutlined,
  LayoutFilled,
  LayoutOutlined,
  LeftCircleFilled,
  LeftCircleOutlined,
  LeftOutlined,
  LeftSquareFilled,
  LeftSquareOutlined,
  LikeFilled,
  LikeOutlined,
  LineChartOutlined,
  LineHeightOutlined,
  LineOutlined,
  LinkOutlined,
  LinkedinFilled,
  LinkedinOutlined,
  Loading3QuartersOutlined,
  LoadingOutlined,
  LockFilled,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MacCommandFilled,
  MacCommandOutlined,
  MailFilled,
  MailOutlined,
  ManOutlined,
  MedicineBoxFilled,
  MedicineBoxOutlined,
  MediumCircleFilled,
  MediumOutlined,
  MediumSquareFilled,
  MediumWorkmarkOutlined,
  MehFilled,
  MehOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  MergeCellsOutlined,
  MessageFilled,
  MessageOutlined,
  MinusCircleFilled,
  MinusCircleOutlined,
  MinusOutlined,
  MinusSquareFilled,
  MinusSquareOutlined,
  MobileFilled,
  MobileOutlined,
  MoneyCollectFilled,
  MoneyCollectOutlined,
  MonitorOutlined,
  MoreOutlined,
  NodeCollapseOutlined,
  NodeExpandOutlined,
  NodeIndexOutlined,
  NotificationFilled,
  NotificationOutlined,
  NumberOutlined,
  OneToOneOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PauseCircleFilled,
  PauseCircleOutlined,
  PauseOutlined,
  PayCircleFilled,
  PayCircleOutlined,
  PercentageOutlined,
  PhoneFilled,
  PhoneOutlined,
  PicCenterOutlined,
  PicLeftOutlined,
  PicRightOutlined,
  PictureFilled,
  PictureOutlined,
  PieChartFilled,
  PieChartOutlined,
  PlayCircleFilled,
  PlayCircleOutlined,
  PlaySquareFilled,
  PlaySquareOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  PlusOutlined,
  PlusSquareFilled,
  PlusSquareOutlined,
  PoundCircleFilled,
  PoundCircleOutlined,
  PoundOutlined,
  PoweroffOutlined,
  PrinterFilled,
  PrinterOutlined,
  ProfileFilled,
  ProfileOutlined,
  ProjectFilled,
  ProjectOutlined,
  PropertySafetyFilled,
  PropertySafetyOutlined,
  PullRequestOutlined,
  PushpinFilled,
  PushpinOutlined,
  QqCircleFilled,
  QqOutlined,
  QqSquareFilled,
  QrcodeOutlined,
  QuestionCircleFilled,
  QuestionCircleOutlined,
  QuestionOutlined,
  RadarChartOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusSettingOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
  ReadFilled,
  ReadOutlined,
  ReconciliationFilled,
  ReconciliationOutlined,
  RedEnvelopeFilled,
  RedEnvelopeOutlined,
  RedditCircleFilled,
  RedditOutlined,
  RedditSquareFilled,
  RedoOutlined,
  ReloadOutlined,
  RestFilled,
  RestOutlined,
  RetweetOutlined,
  RightCircleFilled,
  RightCircleOutlined,
  RightOutlined,
  RightSquareFilled,
  RightSquareOutlined,
  RiseOutlined,
  RobotFilled,
  RobotOutlined,
  RocketFilled,
  RocketOutlined,
  RollbackOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SafetyCertificateFilled,
  SafetyCertificateOutlined,
  SafetyOutlined,
  SaveFilled,
  SaveOutlined,
  ScanOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ScissorOutlined,
  SearchOutlined,
  SecurityScanFilled,
  SecurityScanOutlined,
  SelectOutlined,
  SendOutlined,
  SettingFilled,
  SettingOutlined,
  ShakeOutlined,
  ShareAltOutlined,
  ShopFilled,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingFilled,
  ShoppingOutlined,
  ShrinkOutlined,
  SignalFilled,
  SisternodeOutlined,
  SketchCircleFilled,
  SketchOutlined,
  SketchSquareFilled,
  SkinFilled,
  SkinOutlined,
  SkypeFilled,
  SkypeOutlined,
  SlackCircleFilled,
  SlackOutlined,
  SlackSquareFilled,
  SlackSquareOutlined,
  SlidersFilled,
  SlidersOutlined,
  SmallDashOutlined,
  SmileFilled,
  SmileOutlined,
  SnippetsFilled,
  SnippetsOutlined,
  SolutionOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  SoundFilled,
  SoundOutlined,
  SplitCellsOutlined,
  StarFilled,
  StarOutlined,
  StepBackwardFilled,
  StepBackwardOutlined,
  StepForwardFilled,
  StepForwardOutlined,
  StockOutlined,
  StopFilled,
  StopOutlined,
  StrikethroughOutlined,
  SubnodeOutlined,
  SwapLeftOutlined,
  SwapOutlined,
  SwapRightOutlined,
  SwitcherFilled,
  SwitcherOutlined,
  SyncOutlined,
  TableOutlined,
  TabletFilled,
  TabletOutlined,
  TagFilled,
  TagOutlined,
  TagsFilled,
  TagsOutlined,
  TaobaoCircleFilled,
  TaobaoCircleOutlined,
  TaobaoOutlined,
  TaobaoSquareFilled,
  TeamOutlined,
  ThunderboltFilled,
  ThunderboltOutlined,
  ToTopOutlined,
  ToolFilled,
  ToolOutlined,
  TrademarkCircleFilled,
  TrademarkCircleOutlined,
  TrademarkOutlined,
  TransactionOutlined,
  TranslationOutlined,
  TrophyFilled,
  TrophyOutlined,
  TwitterCircleFilled,
  TwitterOutlined,
  TwitterSquareFilled,
  UnderlineOutlined,
  UndoOutlined,
  UngroupOutlined,
  UnlockFilled,
  UnlockOutlined,
  UnorderedListOutlined,
  UpCircleFilled,
  UpCircleOutlined,
  UpOutlined,
  UpSquareFilled,
  UpSquareOutlined,
  UploadOutlined,
  UsbFilled,
  UsbOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  UsergroupDeleteOutlined,
  VerifiedOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
  VideoCameraAddOutlined,
  VideoCameraFilled,
  VideoCameraOutlined,
  WalletFilled,
  WalletOutlined,
  WarningFilled,
  WarningOutlined,
  WechatFilled,
  WechatOutlined,
  WeiboCircleFilled,
  WeiboCircleOutlined,
  WeiboOutlined,
  WeiboSquareFilled,
  WeiboSquareOutlined,
  WhatsAppOutlined,
  WifiOutlined,
  WindowsFilled,
  WindowsOutlined,
  WomanOutlined,
  YahooFilled,
  YahooOutlined,
  YoutubeFilled,
  YoutubeOutlined,
  YuqueFilled,
  YuqueOutlined,
  ZhihuCircleFilled,
  ZhihuOutlined,
  ZhihuSquareFilled,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons-vue";

export default defineComponent({
  isGlobal: true,
  name: "AntIcon",
  components: {
    AccountBookFilled,
    AccountBookOutlined,
    AimOutlined,
    AlertFilled,
    AlertOutlined,
    AlibabaOutlined,
    AlignCenterOutlined,
    AlignLeftOutlined,
    AlignRightOutlined,
    AlipayCircleFilled,
    AlipayCircleOutlined,
    AlipayOutlined,
    AlipaySquareFilled,
    AliwangwangFilled,
    AliwangwangOutlined,
    AliyunOutlined,
    AmazonCircleFilled,
    AmazonOutlined,
    AmazonSquareFilled,
    AndroidFilled,
    AndroidOutlined,
    AntCloudOutlined,
    AntDesignOutlined,
    ApartmentOutlined,
    ApiFilled,
    ApiOutlined,
    AppleFilled,
    AppleOutlined,
    AppstoreAddOutlined,
    AppstoreFilled,
    AppstoreOutlined,
    AreaChartOutlined,
    ArrowDownOutlined,
    ArrowLeftOutlined,
    ArrowRightOutlined,
    ArrowUpOutlined,
    ArrowsAltOutlined,
    AudioFilled,
    AudioMutedOutlined,
    AudioOutlined,
    AuditOutlined,
    BackwardFilled,
    BackwardOutlined,
    BankFilled,
    BankOutlined,
    BarChartOutlined,
    BarcodeOutlined,
    BarsOutlined,
    BehanceCircleFilled,
    BehanceOutlined,
    BehanceSquareFilled,
    BehanceSquareOutlined,
    BellFilled,
    BellOutlined,
    BgColorsOutlined,
    BlockOutlined,
    BoldOutlined,
    BookFilled,
    BookOutlined,
    BorderBottomOutlined,
    BorderHorizontalOutlined,
    BorderInnerOutlined,
    BorderLeftOutlined,
    BorderOuterOutlined,
    BorderOutlined,
    BorderRightOutlined,
    BorderTopOutlined,
    BorderVerticleOutlined,
    BorderlessTableOutlined,
    BoxPlotFilled,
    BoxPlotOutlined,
    BranchesOutlined,
    BugFilled,
    BugOutlined,
    BuildFilled,
    BuildOutlined,
    BulbFilled,
    BulbOutlined,
    CalculatorFilled,
    CalculatorOutlined,
    CalendarFilled,
    CalendarOutlined,
    CameraFilled,
    CameraOutlined,
    CarFilled,
    CarOutlined,
    CaretDownFilled,
    CaretDownOutlined,
    CaretLeftFilled,
    CaretLeftOutlined,
    CaretRightFilled,
    CaretRightOutlined,
    CaretUpFilled,
    CaretUpOutlined,
    CarryOutFilled,
    CarryOutOutlined,
    CheckCircleFilled,
    CheckCircleOutlined,
    CheckOutlined,
    CheckSquareFilled,
    CheckSquareOutlined,
    ChromeFilled,
    ChromeOutlined,
    CiCircleFilled,
    CiCircleOutlined,
    CiOutlined,
    ClearOutlined,
    ClockCircleFilled,
    ClockCircleOutlined,
    CloseCircleFilled,
    CloseCircleOutlined,
    CloseOutlined,
    CloseSquareFilled,
    CloseSquareOutlined,
    CloudDownloadOutlined,
    CloudFilled,
    CloudOutlined,
    CloudServerOutlined,
    CloudSyncOutlined,
    CloudUploadOutlined,
    ClusterOutlined,
    CodeFilled,
    CodeOutlined,
    CodeSandboxCircleFilled,
    CodeSandboxOutlined,
    CodeSandboxSquareFilled,
    CodepenCircleFilled,
    CodepenCircleOutlined,
    CodepenOutlined,
    CodepenSquareFilled,
    CoffeeOutlined,
    ColumnHeightOutlined,
    ColumnWidthOutlined,
    CommentOutlined,
    CompassFilled,
    CompassOutlined,
    CompressOutlined,
    ConsoleSqlOutlined,
    ContactsFilled,
    ContactsOutlined,
    ContainerFilled,
    ContainerOutlined,
    ControlFilled,
    ControlOutlined,
    CopyFilled,
    CopyOutlined,
    CopyrightCircleFilled,
    CopyrightCircleOutlined,
    CopyrightOutlined,
    CreditCardFilled,
    CreditCardOutlined,
    CrownFilled,
    CrownOutlined,
    CustomerServiceFilled,
    CustomerServiceOutlined,
    DashOutlined,
    DashboardFilled,
    DashboardOutlined,
    DatabaseFilled,
    DatabaseOutlined,
    DeleteColumnOutlined,
    DeleteFilled,
    DeleteOutlined,
    DeleteRowOutlined,
    DeliveredProcedureOutlined,
    DeploymentUnitOutlined,
    DesktopOutlined,
    DiffFilled,
    DiffOutlined,
    DingdingOutlined,
    DingtalkCircleFilled,
    DingtalkOutlined,
    DingtalkSquareFilled,
    DisconnectOutlined,
    DislikeFilled,
    DislikeOutlined,
    DollarCircleFilled,
    DollarCircleOutlined,
    DollarOutlined,
    DotChartOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    DownCircleFilled,
    DownCircleOutlined,
    DownOutlined,
    DownSquareFilled,
    DownSquareOutlined,
    DownloadOutlined,
    DragOutlined,
    DribbbleCircleFilled,
    DribbbleOutlined,
    DribbbleSquareFilled,
    DribbbleSquareOutlined,
    DropboxCircleFilled,
    DropboxOutlined,
    DropboxSquareFilled,
    EditFilled,
    EditOutlined,
    EllipsisOutlined,
    EnterOutlined,
    EnvironmentFilled,
    EnvironmentOutlined,
    EuroCircleFilled,
    EuroCircleOutlined,
    EuroOutlined,
    ExceptionOutlined,
    ExclamationCircleFilled,
    ExclamationCircleOutlined,
    ExclamationOutlined,
    ExpandAltOutlined,
    ExpandOutlined,
    ExperimentFilled,
    ExperimentOutlined,
    ExportOutlined,
    EyeFilled,
    EyeInvisibleFilled,
    EyeInvisibleOutlined,
    EyeOutlined,
    FacebookFilled,
    FacebookOutlined,
    FallOutlined,
    FastBackwardFilled,
    FastBackwardOutlined,
    FastForwardFilled,
    FastForwardOutlined,
    FieldBinaryOutlined,
    FieldNumberOutlined,
    FieldStringOutlined,
    FieldTimeOutlined,
    FileAddFilled,
    FileAddOutlined,
    FileDoneOutlined,
    FileExcelFilled,
    FileExcelOutlined,
    FileExclamationFilled,
    FileExclamationOutlined,
    FileFilled,
    FileGifOutlined,
    FileImageFilled,
    FileImageOutlined,
    FileJpgOutlined,
    FileMarkdownFilled,
    FileMarkdownOutlined,
    FileOutlined,
    FilePdfFilled,
    FilePdfOutlined,
    FilePptFilled,
    FilePptOutlined,
    FileProtectOutlined,
    FileSearchOutlined,
    FileSyncOutlined,
    FileTextFilled,
    FileTextOutlined,
    FileUnknownFilled,
    FileUnknownOutlined,
    FileWordFilled,
    FileWordOutlined,
    FileZipFilled,
    FileZipOutlined,
    FilterFilled,
    FilterOutlined,
    FireFilled,
    FireOutlined,
    FlagFilled,
    FlagOutlined,
    FolderAddFilled,
    FolderAddOutlined,
    FolderFilled,
    FolderOpenFilled,
    FolderOpenOutlined,
    FolderOutlined,
    FolderViewOutlined,
    FontColorsOutlined,
    FontSizeOutlined,
    ForkOutlined,
    FormOutlined,
    FormatPainterFilled,
    FormatPainterOutlined,
    ForwardFilled,
    ForwardOutlined,
    FrownFilled,
    FrownOutlined,
    FullscreenExitOutlined,
    FullscreenOutlined,
    FunctionOutlined,
    FundFilled,
    FundOutlined,
    FundProjectionScreenOutlined,
    FundViewOutlined,
    FunnelPlotFilled,
    FunnelPlotOutlined,
    GatewayOutlined,
    GifOutlined,
    GiftFilled,
    GiftOutlined,
    GithubFilled,
    GithubOutlined,
    GitlabFilled,
    GitlabOutlined,
    GlobalOutlined,
    GoldFilled,
    GoldOutlined,
    GoldenFilled,
    GoogleCircleFilled,
    GoogleOutlined,
    GooglePlusCircleFilled,
    GooglePlusOutlined,
    GooglePlusSquareFilled,
    GoogleSquareFilled,
    GroupOutlined,
    HddFilled,
    HddOutlined,
    HeartFilled,
    HeartOutlined,
    HeatMapOutlined,
    HighlightFilled,
    HighlightOutlined,
    HistoryOutlined,
    HomeFilled,
    HomeOutlined,
    HourglassFilled,
    HourglassOutlined,
    Html5Filled,
    Html5Outlined,
    IdcardFilled,
    IdcardOutlined,
    IeCircleFilled,
    IeOutlined,
    IeSquareFilled,
    ImportOutlined,
    InboxOutlined,
    InfoCircleFilled,
    InfoCircleOutlined,
    InfoOutlined,
    InsertRowAboveOutlined,
    InsertRowBelowOutlined,
    InsertRowLeftOutlined,
    InsertRowRightOutlined,
    InstagramFilled,
    InstagramOutlined,
    InsuranceFilled,
    InsuranceOutlined,
    InteractionFilled,
    InteractionOutlined,
    IssuesCloseOutlined,
    ItalicOutlined,
    KeyOutlined,
    LaptopOutlined,
    LayoutFilled,
    LayoutOutlined,
    LeftCircleFilled,
    LeftCircleOutlined,
    LeftOutlined,
    LeftSquareFilled,
    LeftSquareOutlined,
    LikeFilled,
    LikeOutlined,
    LineChartOutlined,
    LineHeightOutlined,
    LineOutlined,
    LinkOutlined,
    LinkedinFilled,
    LinkedinOutlined,
    Loading3QuartersOutlined,
    LoadingOutlined,
    LockFilled,
    LockOutlined,
    LoginOutlined,
    LogoutOutlined,
    MacCommandFilled,
    MacCommandOutlined,
    MailFilled,
    MailOutlined,
    ManOutlined,
    MedicineBoxFilled,
    MedicineBoxOutlined,
    MediumCircleFilled,
    MediumOutlined,
    MediumSquareFilled,
    MediumWorkmarkOutlined,
    MehFilled,
    MehOutlined,
    MenuFoldOutlined,
    MenuOutlined,
    MenuUnfoldOutlined,
    MergeCellsOutlined,
    MessageFilled,
    MessageOutlined,
    MinusCircleFilled,
    MinusCircleOutlined,
    MinusOutlined,
    MinusSquareFilled,
    MinusSquareOutlined,
    MobileFilled,
    MobileOutlined,
    MoneyCollectFilled,
    MoneyCollectOutlined,
    MonitorOutlined,
    MoreOutlined,
    NodeCollapseOutlined,
    NodeExpandOutlined,
    NodeIndexOutlined,
    NotificationFilled,
    NotificationOutlined,
    NumberOutlined,
    OneToOneOutlined,
    OrderedListOutlined,
    PaperClipOutlined,
    PartitionOutlined,
    PauseCircleFilled,
    PauseCircleOutlined,
    PauseOutlined,
    PayCircleFilled,
    PayCircleOutlined,
    PercentageOutlined,
    PhoneFilled,
    PhoneOutlined,
    PicCenterOutlined,
    PicLeftOutlined,
    PicRightOutlined,
    PictureFilled,
    PictureOutlined,
    PieChartFilled,
    PieChartOutlined,
    PlayCircleFilled,
    PlayCircleOutlined,
    PlaySquareFilled,
    PlaySquareOutlined,
    PlusCircleFilled,
    PlusCircleOutlined,
    PlusOutlined,
    PlusSquareFilled,
    PlusSquareOutlined,
    PoundCircleFilled,
    PoundCircleOutlined,
    PoundOutlined,
    PoweroffOutlined,
    PrinterFilled,
    PrinterOutlined,
    ProfileFilled,
    ProfileOutlined,
    ProjectFilled,
    ProjectOutlined,
    PropertySafetyFilled,
    PropertySafetyOutlined,
    PullRequestOutlined,
    PushpinFilled,
    PushpinOutlined,
    QqCircleFilled,
    QqOutlined,
    QqSquareFilled,
    QrcodeOutlined,
    QuestionCircleFilled,
    QuestionCircleOutlined,
    QuestionOutlined,
    RadarChartOutlined,
    RadiusBottomleftOutlined,
    RadiusBottomrightOutlined,
    RadiusSettingOutlined,
    RadiusUpleftOutlined,
    RadiusUprightOutlined,
    ReadFilled,
    ReadOutlined,
    ReconciliationFilled,
    ReconciliationOutlined,
    RedEnvelopeFilled,
    RedEnvelopeOutlined,
    RedditCircleFilled,
    RedditOutlined,
    RedditSquareFilled,
    RedoOutlined,
    ReloadOutlined,
    RestFilled,
    RestOutlined,
    RetweetOutlined,
    RightCircleFilled,
    RightCircleOutlined,
    RightOutlined,
    RightSquareFilled,
    RightSquareOutlined,
    RiseOutlined,
    RobotFilled,
    RobotOutlined,
    RocketFilled,
    RocketOutlined,
    RollbackOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    SafetyCertificateFilled,
    SafetyCertificateOutlined,
    SafetyOutlined,
    SaveFilled,
    SaveOutlined,
    ScanOutlined,
    ScheduleFilled,
    ScheduleOutlined,
    ScissorOutlined,
    SearchOutlined,
    SecurityScanFilled,
    SecurityScanOutlined,
    SelectOutlined,
    SendOutlined,
    SettingFilled,
    SettingOutlined,
    ShakeOutlined,
    ShareAltOutlined,
    ShopFilled,
    ShopOutlined,
    ShoppingCartOutlined,
    ShoppingFilled,
    ShoppingOutlined,
    ShrinkOutlined,
    SignalFilled,
    SisternodeOutlined,
    SketchCircleFilled,
    SketchOutlined,
    SketchSquareFilled,
    SkinFilled,
    SkinOutlined,
    SkypeFilled,
    SkypeOutlined,
    SlackCircleFilled,
    SlackOutlined,
    SlackSquareFilled,
    SlackSquareOutlined,
    SlidersFilled,
    SlidersOutlined,
    SmallDashOutlined,
    SmileFilled,
    SmileOutlined,
    SnippetsFilled,
    SnippetsOutlined,
    SolutionOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined,
    SoundFilled,
    SoundOutlined,
    SplitCellsOutlined,
    StarFilled,
    StarOutlined,
    StepBackwardFilled,
    StepBackwardOutlined,
    StepForwardFilled,
    StepForwardOutlined,
    StockOutlined,
    StopFilled,
    StopOutlined,
    StrikethroughOutlined,
    SubnodeOutlined,
    SwapLeftOutlined,
    SwapOutlined,
    SwapRightOutlined,
    SwitcherFilled,
    SwitcherOutlined,
    SyncOutlined,
    TableOutlined,
    TabletFilled,
    TabletOutlined,
    TagFilled,
    TagOutlined,
    TagsFilled,
    TagsOutlined,
    TaobaoCircleFilled,
    TaobaoCircleOutlined,
    TaobaoOutlined,
    TaobaoSquareFilled,
    TeamOutlined,
    ThunderboltFilled,
    ThunderboltOutlined,
    ToTopOutlined,
    ToolFilled,
    ToolOutlined,
    TrademarkCircleFilled,
    TrademarkCircleOutlined,
    TrademarkOutlined,
    TransactionOutlined,
    TranslationOutlined,
    TrophyFilled,
    TrophyOutlined,
    TwitterCircleFilled,
    TwitterOutlined,
    TwitterSquareFilled,
    UnderlineOutlined,
    UndoOutlined,
    UngroupOutlined,
    UnlockFilled,
    UnlockOutlined,
    UnorderedListOutlined,
    UpCircleFilled,
    UpCircleOutlined,
    UpOutlined,
    UpSquareFilled,
    UpSquareOutlined,
    UploadOutlined,
    UsbFilled,
    UsbOutlined,
    UserAddOutlined,
    UserDeleteOutlined,
    UserOutlined,
    UserSwitchOutlined,
    UsergroupAddOutlined,
    UsergroupDeleteOutlined,
    VerifiedOutlined,
    VerticalAlignBottomOutlined,
    VerticalAlignMiddleOutlined,
    VerticalAlignTopOutlined,
    VerticalLeftOutlined,
    VerticalRightOutlined,
    VideoCameraAddOutlined,
    VideoCameraFilled,
    VideoCameraOutlined,
    WalletFilled,
    WalletOutlined,
    WarningFilled,
    WarningOutlined,
    WechatFilled,
    WechatOutlined,
    WeiboCircleFilled,
    WeiboCircleOutlined,
    WeiboOutlined,
    WeiboSquareFilled,
    WeiboSquareOutlined,
    WhatsAppOutlined,
    WifiOutlined,
    WindowsFilled,
    WindowsOutlined,
    WomanOutlined,
    YahooFilled,
    YahooOutlined,
    YoutubeFilled,
    YoutubeOutlined,
    YuqueFilled,
    YuqueOutlined,
    ZhihuCircleFilled,
    ZhihuOutlined,
    ZhihuSquareFilled,
    ZoomInOutlined,
    ZoomOutOutlined,
  },
  props: {
    type: {
      type: String,
    },
  },
});
</script>
